import type { IChosenItem } from "app/components/compare/WebsiteQueryBar/WebsitePageQueryBarUtils";
import { allTrackers } from "app/services/track/track";
import type { IWebsitePageResult } from "pro-features/components/AutocompleteWebsites/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { WebsitePageResults } from "./types";

const DEFAULT_PAGE_FILTER_FIELD_NAME = "pageFilter";
const DEFAULT_COMPETITORS_FIELD_NAME = "competitorsFilter";

export type GetPrimarySiteReturnType = Pick<IChosenItem, "url" | "domain" | "searchType" | "icon">;

export const updateUrlWithCompetitors = (
    competitors?: WebsitePageResults,
    paramFieldName = DEFAULT_COMPETITORS_FIELD_NAME,
) => {
    void proNavigator.updateQueryParams(
        {
            [paramFieldName]: JSON.stringify(competitors?.map((c) => ({ url: c.name, searchType: c.searchType }))),
        },
        { reload: false },
    );
};

export const getUpdatedCompetitorsOnAddCompetitor = (
    currentCompetitors: WebsitePageResults,
    competitorToAdd: IWebsitePageResult,
    activeCompetitorIndex: number,
): WebsitePageResults => {
    const before = currentCompetitors.slice(0, activeCompetitorIndex);
    const after = currentCompetitors.slice(activeCompetitorIndex + 1);
    return [...before, competitorToAdd, ...after];
};

const trackInlineQueryBarEvents = (action: string, subEvent?: string) => {
    allTrackers.dispatchTrackEvent("Compare", action, `Competitor Opportunities${subEvent ? `/${subEvent}` : ""}`);
};

export const trackAutocompleteOpen = () => {
    trackInlineQueryBarEvents("Open");
};

export const trackCompetitorsCleared = () => {
    trackInlineQueryBarEvents("Clear");
};

export const trackAutocompleteSelectSite = (site: string) => {
    trackInlineQueryBarEvents("click", site);
};
